// src/modules/LiberacoesFinanceiras/PaymentTable.jsx
import React, { useState } from 'react';
import './PaymentTable.css';
import { formatarData } from '../../utils/formatarDataHora';
import ConfirmationPopup from './ConfirmationPopup';

const PaymentTable = ({ payments, onPaymentsProcessed }) => {
    const [selectedPayments, setSelectedPayments] = useState([]);
    const [showConfirmation, setShowConfirmation] = useState(false);

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedPayments(payments.map((_, index) => index));
        } else {
            setSelectedPayments([]);
        }
    };

    const handleSelectPayment = (index) => {
        if (selectedPayments.includes(index)) {
            setSelectedPayments(selectedPayments.filter(i => i !== index));
        } else {
            setSelectedPayments([...selectedPayments, index]);
        }
    };

    const handleProcessPayments = () => {
        if (selectedPayments.length === 0) {
            window.showAlert('warning', 'Please select at least one payment to process.');
            return;
        }
        setShowConfirmation(true);
    };

    const handleConfirm = () => {
        setShowConfirmation(false);
        // Callback will be handled by ConfirmationPopup
    };

    const handleCancel = () => {
        setShowConfirmation(false);
    };

    const formatCurrency = (value) => {
        const numValue = parseFloat(value);
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(numValue);
    };

    const calculateTotalSelected = () => {
        const total = selectedPayments.reduce((sum, index) => {
            return sum + parseFloat(payments[index].E2_XVALDDA);
        }, 0);
        return formatCurrency(total);
    };

    if (!payments || payments.length === 0) {
        return (
            <div className="payment-table-container">
                <div className="alert alert-info" role="alert">
                    No payments found.
                </div>
            </div>
        );
    }

    const selectedPaymentObjects = selectedPayments.map(index => payments[index]);

    return (
        <div className="payment-table-container">
            <div className="table-header">
                <div className="header-left">
                    <h6 className="mb-0">Pagamentos: {payments.length}</h6>
                </div>
                <div className="header-right">
                    <label className="select-all-label">
                        <input
                            type="checkbox"
                            checked={selectedPayments.length === payments.length}
                            onChange={handleSelectAll}
                        />
                        <span className="ms-2">Selecionar todos</span>
                    </label>
                </div>
            </div>

            {/* Card View */}
            <div className="payment-cards-list">
                {payments.map((payment, index) => (
                        <div
                            key={`${payment.E2_FILIAL}-${payment.E2_NUM}-${index}`}
                            className={`payment-card ${selectedPayments.includes(index) ? 'selected' : ''}`}
                            onClick={() => handleSelectPayment(index)}
                        >
                            <div className="card-header-section">
                                <div className="card-checkbox" onClick={(e) => e.stopPropagation()}>
                                    <input
                                        type="checkbox"
                                        checked={selectedPayments.includes(index)}
                                        onChange={() => handleSelectPayment(index)}
                                    />
                                </div>
                                <div className="card-main-info">
                                    <div className="beneficiary-name">{payment.E2_NOMFOR}</div>
                                    <div className="payment-amount">{formatCurrency(payment.E2_XVALDDA)}</div>
                                </div>
                            </div>
                            
                            <div className="card-details">
                                <div className="detail-row">
                                    <span className="detail-label">Emissão:</span>
                                    <span className="detail-value">{formatarData(`${payment.E2_EMISSAO} - 000000`)}</span>
                                </div>
                                <div className="detail-row">
                                    <span className="detail-label">Vencimento:</span>
                                    <span className="detail-value">{formatarData(`${payment.E2_VENCREA} - 000000`)}</span>
                                </div>
                                <div className="detail-row">
                                    <span className="detail-label">Doc:</span>
                                    <span className="detail-value">{payment.E2_PREFIXO}/{payment.E2_NUM}/{payment.E2_PARCELA}</span>
                                </div>
                                <div className="detail-row">
                                    <span className="detail-label">Filial:</span>
                                    <span className="detail-value">{payment.E2_FILIAL} - {payment.E2_TIPO}</span>
                                </div>
                            </div>
                        </div>
                    ))}
            </div>

            {/* Selection Summary */}
            {selectedPayments.length > 0 && (
                <div className="selection-summary">
                    <div className="summary-item">
                        <span className="summary-label">Selecionados:</span>
                        <span className="summary-value">{selectedPayments.length}</span>
                    </div>
                    <div className="summary-item">
                        <span className="summary-label">Total:</span>
                        <span className="summary-value fw-bold">{calculateTotalSelected()}</span>
                    </div>
                </div>
            )}

            <div className="table-footer">
                <button
                    className="btn btn-success btn-process"
                    onClick={handleProcessPayments}
                    disabled={selectedPayments.length === 0}
                >
                    Autorizar
                </button>
            </div>

            {showConfirmation && (
                <ConfirmationPopup
                    payments={selectedPaymentObjects}
                    onConfirm={handleConfirm}
                    onCancel={handleCancel}
                    onSuccess={() => {
                        setSelectedPayments([]);
                        onPaymentsProcessed();
                    }}
                />
            )}
        </div>
    );
};

export default PaymentTable;
